module.exports = function getResource(label, vars = []) {
    let resources = {
        chooseStore: 'Choose a Store',
        setYourLocation: 'Set Your Location',
        pickup: 'Pickup',
        reset: 'Reset'
    };

    return resources[label];
};
